import { z } from 'zod';
import { CustomerTableColumns } from '@/routes/_stacktrace/customers/-table/type';
import { type CustomerStatus, CustomerStatus as CS, type CustomerStatusFilter } from './-query/type';
const customerStatusValues = Object.values(CS) as [CustomerStatus, ...CustomerStatus[]];
export const CustomerStatusFilterSchema = z.enum(['ALL', ...customerStatusValues]);

/**
 * 顧客一覧のステータスタブ並び順。
 * ライフサイクル順 → 全件:
 *   ACTIVE → SUSPENDED → TERMINATED → ALL
 * 既定タブは ACTIVE (利用中)。
 */
export const STATUS_TABS = [CS.ACTIVE, CS.SUSPENDED, CS.TERMINATED, 'ALL'] as const satisfies readonly CustomerStatusFilter[];
export function buildCustomerTabChangeSearch(tab: string) {
  const result = CustomerStatusFilterSchema.safeParse(tab);
  return {
    status: result.success ? result.data : CS.ACTIVE,
    pageIndex: 0,
    sortColumn: CustomerTableColumns.CODE,
    orderDirection: 'asc' as const
  };
}